var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F7F7F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5006_9549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 24,
    height: 24,
    fill: "#46474C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5006_9549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 30.0387V13.308C10.5 12.8028 10.675 12.3752 11.025 12.0252C11.375 11.6752 11.8026 11.5002 12.3077 11.5002H22.35C22.2962 11.7502 22.2677 11.9986 22.2645 12.2455C22.2613 12.4923 22.277 12.7439 22.3115 13.0002H12.3077C12.2307 13.0002 12.1603 13.0323 12.0963 13.0965C12.0321 13.1605 12 13.231 12 13.308V26.385L13.4 25.0002H27.6923C27.7693 25.0002 27.8398 24.9681 27.9038 24.904C27.9679 24.84 28 24.7695 28 24.6925V17.1215C28.2872 17.0573 28.5542 16.9752 28.801 16.8752C29.0477 16.7752 29.2807 16.6438 29.5 16.481V24.6925C29.5 25.1976 29.325 25.6252 28.975 25.9752C28.625 26.3252 28.1974 26.5002 27.6923 26.5002H14.0385L10.5 30.0387ZM12 13.308V25.6925V13.0002V13.308ZM27 15.231C26.2372 15.231 25.5882 14.9634 25.053 14.4282C24.5177 13.8929 24.25 13.2438 24.25 12.481C24.25 11.7181 24.5177 11.0691 25.053 10.534C25.5882 9.99862 26.2372 9.73096 27 9.73096C27.7628 9.73096 28.4118 9.99862 28.947 10.534C29.4823 11.0691 29.75 11.7181 29.75 12.481C29.75 13.2438 29.4823 13.8929 28.947 14.4282C28.4118 14.9634 27.7628 15.231 27 15.231Z",
    fill: "#46474C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardChat);
export default __webpack_public_path__ + "static/media/electricboard-chat.a5e0e7967a5e6428da32461668a4dea2.svg";
export { ForwardRef as ReactComponent };